'use strict';

import Cookie from 'js-cookie';

import API from '../../../api/api';

export const RECEIVE_PROJECT_FILES = 'RECEIVE_PROJECT_FILES';
// export const ADD_PROJECT_FILES    = 'ADD_PROJECT_FILES';
// export const REMOVE_PROJECT_FILES = 'REMOVE_PROJECT_FILES';
// export const CLEAR_PROJECT        = 'CLEAR_PROJECT';

export const getProjectFiles = () => dispatch => {
    return dispatch({
        type: 'GET_PROJECT_FILES',
        payload: API('GetProjectFiles', {
            sessionID: Cookie.get('PHPSESSID'),
        }).then(res => {
            return dispatch(receiveProjectFiles(res));
        }),
    });
}

const receiveProjectFiles = (files) => ({
    type: RECEIVE_PROJECT_FILES,
    files
})

// const addProjectFiles = (files) => ({
//     type: ADD_PROJECT_FILES,
//     files
// })

export const removeProjectFile = (uid) => dispatch => {
    return dispatch({
        type: 'REMOVE_PROJECT_FILE',
        payload: API('RemoveProjectFile', {
            sessionID: Cookie.get('PHPSESSID'),
            uid: uid,
        }).then(res => {
            return dispatch(receiveProjectFiles(res));
        }),
    });
}

// const clearProject = () => ({
//     type: CLEAR_PROJECT,
// })



// WEBPACK FOOTER //
// ./src/project/project-files/state/actions.js